import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams, useLocation, useRouteMatch } from 'react-router-dom';
import { CRUDFormField } from './CRUDFormField';
import { translate } from '../../../Services/translation';

export const CRUDForm = ({ model, actionName, SaveBtnName = translate('coptikk.adminportal.savebuttontext') }) => {
    const { headers, requestGetItem, requestPostData, validation, root } = model;
    const rawState = headers.map(({ headerName }) => headerName).reduce((acc, curr) => (acc[curr] = "", acc), {});
    const [data, setData] = useState({ ...rawState });
    const [errors, setErrors] = useState({});
    const { id } = useParams();
    const history = useNavigate();
    const location = useLocation();
    const updateData = (headerName, value) => {
        setData(prev => ({ ...prev, [headerName]: value }));
    }

    const onChangeHandler = useCallback(
        ({ target: { name, value } }) => updateData(name, value), [data, setData]);

    const onChangeHandlerBoolean = useCallback(
        ({ target: { name, checked } }) => updateData(name, checked), [data, setData]);

    function clearData() {
        setPublish(false);
    }

    const save = (e) => {
        e.preventDefault();
        validation.validate(data, { abortEarly: false })
            .then(() => {
                setErrors({});
                if (!requestPostData) {
                    console.error('Data is not saved, requestPostData is not defined, navigate to default path');
                    history.push(`/${root}`)
                }
                requestPostData(id, data).then(() => history(`/${root}`))
                    .catch(err => {
                        if (err) {
                            err.response.clone().text().then(message => alert(message));
                        }
                    });
            })
            .catch(error => {

                if (error && error.inner) {
                    setErrors(error.inner.map(({ path, type }) => ({ [path]: { type } })).reduce((r, c) => ({ ...r, ...c })));
                } else {
                    setErrors({ message: error });
                }
                console.error(error);
            });
        
        clearData()
    };

    useEffect(() => {
        if (!!id) {
            if (!requestGetItem) {
                console.error("requestGetItem is not defined");
            } else {
                requestGetItem(id).then((resp) => {
                    const result = resp && resp.blockViewModel ? resp.blockViewModel : resp;
                    setData(prev => ({ ...prev, ...result }));
                });
            }
        }
        
    }, [id, setData]);

    function setPublish(publish) {
        updateData('publish', publish)
    }

    return (

        <div className="backend__article-edit">
            <form onSubmit={(e) => save(e)}>
                <div className="row page-header">
                    <div className={`columns small-${model.canPublish ? 6 : 9}`}>
                        <h1 className="page__title">{actionName}</h1>
                    </div>
                    <div className={`columns small-${model.canPublish ? 6 :3} flex-container`}>
                        <div className={`columns small-${model.canPublish ? 6 : 12}`}>
                            <button type="submit" className="button large expanded">{translate('coptikk.adminportal.savebuttontext')}</button>
                        </div>
                        {model.canPublish && (
                            <div className="columns small-6">
                                <button type="submit" className="button large expanded" onClick={() => setPublish(true)} data-publish={true}>{translate("coptikk.adminportal.publishbuttontext")}</button>
                            </div>
                        )}
                    </div>
                </div>

                {data.publishedInformationText && (
                    <div className="row">
                        <div className="columns small-12">
                            <div className="columns small-12 text-right">
                                <b>{data.publishedInformationText}</b>
                            </div>
                        </div>
                    </div>
                )}

                {headers.map(({ headerName, typeName, isHiddenInForm, label, isDisabled, selectOptions }) =>
                    !isHiddenInForm ? <CRUDFormField
                        selectOptions={selectOptions}
                        errors={errors}
                        isDisabled={isDisabled}
                        key={headerName}
                        headerName={headerName}
                        label={label}
                        onChangeHandler={onChangeHandler}
                        onChangeHandlerBoolean={onChangeHandlerBoolean}
                        fieldValue={data[headerName]}
                        typeName={typeName}
                        updateData={updateData} />
                        : null)}
            </form>
        </div>
    )
}